var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 22,
  viewBox: "0 0 32 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 0C1.79086 0 0 1.79086 0 4V18C0 20.2091 1.79086 22 4 22H28C30.2091 22 32 20.2091 32 18V4C32 1.79086 30.2091 0 28 0H4ZM5 5H13V7H5V5ZM5 16H9V18H5V16ZM15 16V18H11V16H15ZM17 16H21V18H17V16ZM23 16H27V18H23V16Z",
  fill: "white"
})));
export { SvgCreditCard as ReactComponent };
export default __webpack_public_path__ + "assets/icons/credit_card.8374d6.svg";